/**
 * Single source of truth for outbound contact channels.
 *
 * The values are intentionally NOT routed through react-i18next: the email
 * address is the same in zh-CN and en (the brand "Nexnovar" stays as-is in
 * both languages, per .skills/i18n-workflow §8). Only the surrounding copy
 * (e.g. "Contact us") is bilingual.
 *
 * To change a contact address, edit this file once. Every component that
 * imports from `@/lib/contact` picks up the change on the next build.
 */

export const CONTACT_SALES_EMAIL = 'service@nexnovar.com';

export const CONTACT_SALES_EMAIL_HREF = `mailto:${CONTACT_SALES_EMAIL}`;
